{
  "name": "TNT Increase Button",
  "powerupName": "TNTBlobs",
  "levelUpDescriptions": [
    "TNTUpgradeDescription1",
    "TNTUpgradeDescription2",
    "TNTUpgradeDescription3",
    "TNTUpgradeDescription4",
    "TNTUpgradeDescription5"
  ]
}